import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../spinner'
import { ButtonContained } from '../app-button/button'
import { required, url } from './validation/validation'
import InputOutlined from './field/inputOutlined'

const styles = theme => ({
  form: {
    width: 343,
    marginTop: 20,
  },
  novalidate: {},

  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
})

class SiteForm extends Component {
  state = {
    focus: false,
  }

  resetValueField = name => {
    this.props.change(this.props.form, name, '')
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  componentDidMount() {
    this.setState(({ focus }) => {
      return { focus: !focus }
    })
  }

  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <Field
          name="name"
          label="Название проекта"
          component={InputOutlined}
          type="text"
          focus={this.state.focus}
          validate={[required]}
        />

        <Field
          name="url"
          label="URL"
          component={InputOutlined}
          type="text"
          validate={[required, url]}
          handleResetField={this.resetValueField}
        />

        <ButtonContained
          style={{
            height: 48,
            fontSize: 16,
            width: '100%',
            padding: 0,
            fontWeight: 700,
            color: '#fff',
          }}
          type="submit"
          color="secondary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={isFetching ? <Spinner /> : 'Сохранить'}
        />
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

SiteForm = reduxForm({
  form: 'site',
})(
  connect(
    null,
    mapDispatchToProps
  )(SiteForm)
)

export default withStyles(styles)(SiteForm)
